/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { YoutubeIntegrationGetBroadcastsQueryResponse, YoutubeIntegrationGetBroadcastsPathParams, YoutubeIntegrationGetBroadcastsQueryParams, YoutubeIntegrationGetBroadcasts401, YoutubeIntegrationGetBroadcasts403 } from "../models/YoutubeIntegrationGetBroadcasts";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { youtubeIntegrationGetBroadcasts } from "../axios/youtubeIntegrationGetBroadcasts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const youtubeIntegrationGetBroadcastsQueryKey = (station: YoutubeIntegrationGetBroadcastsPathParams["station"], params: YoutubeIntegrationGetBroadcastsQueryParams) => ["api-v2", { url: '/youtube-integration/v1/broadcasts/:station', params: {station:station} }, ...(params ? [params] : [])] as const

export type YoutubeIntegrationGetBroadcastsQueryKey = ReturnType<typeof youtubeIntegrationGetBroadcastsQueryKey>

export function youtubeIntegrationGetBroadcastsQueryOptions(station: YoutubeIntegrationGetBroadcastsPathParams["station"], params: YoutubeIntegrationGetBroadcastsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = youtubeIntegrationGetBroadcastsQueryKey(station, params)
        return queryOptions<YoutubeIntegrationGetBroadcastsQueryResponse, ResponseErrorConfig<YoutubeIntegrationGetBroadcasts401 | YoutubeIntegrationGetBroadcasts403>, YoutubeIntegrationGetBroadcastsQueryResponse, typeof queryKey>({
         enabled: !!(station&& params),
         queryKey,
         queryFn: async ({ signal }) => {
            return youtubeIntegrationGetBroadcasts(station, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Computes on-air intervals from stream gaps in the requested window, matches live/ended YouTube videos for the station channel, and returns enriched broadcast rows sorted most-recent first.
 * @summary List on-air broadcasts for a station
 * {@link /youtube-integration/v1/broadcasts/:station}
 */
export function useYoutubeIntegrationGetBroadcasts<TData = YoutubeIntegrationGetBroadcastsQueryResponse, TQueryData = YoutubeIntegrationGetBroadcastsQueryResponse, TQueryKey extends QueryKey = YoutubeIntegrationGetBroadcastsQueryKey>(station: YoutubeIntegrationGetBroadcastsPathParams["station"], params: YoutubeIntegrationGetBroadcastsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<YoutubeIntegrationGetBroadcastsQueryResponse, ResponseErrorConfig<YoutubeIntegrationGetBroadcasts401 | YoutubeIntegrationGetBroadcasts403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? youtubeIntegrationGetBroadcastsQueryKey(station, params)
         

         const query = useQuery({
          ...youtubeIntegrationGetBroadcastsQueryOptions(station, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<YoutubeIntegrationGetBroadcasts401 | YoutubeIntegrationGetBroadcasts403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}